import { render, staticRenderFns } from "./ModalVisualizarHistorialDetalleSolicitud.vue?vue&type=template&id=312ffb91"
import script from "./ModalVisualizarHistorialDetalleSolicitud.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarHistorialDetalleSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports